import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../../../core/domain/Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {RefundModel} from './Refund.model';

@injectable()
export class RefundFactory
  implements BaseDomainFactory<RefundModel, RefundModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: RefundModel.Props): RefundModel {
    return this.modelsRegistry.put(new RefundModel(props));
  }
}
